import { Waypoints } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { isPathWorkspace, workspaceLocation } from '@/services/workspaces';

/**
 * Refusal for a workspace placed under a path (`example.com/fr`), wherever a screen
 * would author one.
 *
 * Its configuration is its own (IX-5071). Its knowledge and the other hostname-keyed
 * screens cannot be authored yet: the admin API and ingestion still key those by
 * hostname, so the screen would read and write the workspace that owns the whole
 * host. Refusing is the correct behaviour until they take a workspace id (IX-5070);
 * analytics stay available and cover the whole host.
 */
export function PathWorkspaceNotice() {
    const { selectedWorkspace, selectedDomain, selectWorkspace, workspaces } = useWorkspace();
    if (!selectedWorkspace) return null;
    const hostWorkspace = workspaces.find(
        (w) => w.domain === selectedDomain && !isPathWorkspace(w)
    );

    return (
        <EmptyState
            className="path-workspace-studio-notice"
            icon={<Waypoints />}
            title="This part of the workspace is managed by Rose for now"
            description={`${selectedWorkspace.name} lives at ${workspaceLocation(selectedWorkspace)} and shares its website with another workspace. This screen can't be edited for it yet; its brand, questions, calls-to-action and agent settings can. Analytics are available and cover the whole website.`}
            action={
                hostWorkspace && (
                    <Button variant="outline" onClick={() => selectWorkspace(hostWorkspace.id)}>
                        Open {hostWorkspace.name}
                    </Button>
                )
            }
        />
    );
}
